import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { TagComponent } from './tag.component';
import { TagCreateComponent } from './tag-create/tag-create.component';
import { TagEditComponent } from './tag-edit/tag-edit.component';
import { TagFormComponent } from './shared/tag-form/tag-form.component';
import { TagService } from './shared/tag.service';
import { FormsService } from '../shared/forms.service';

@NgModule({
  imports: [
    SharedModule,
  ],
  providers: [
    TagService,
    FormsService
  ],
  declarations: [ TagComponent, TagCreateComponent, TagEditComponent, TagFormComponent ]
})
export class TagModule { }



// WEBPACK FOOTER //
// ./src/app/tags/tag.module.ts